import { render, staticRenderFns } from "./SendWelcomeEmailButton.vue?vue&type=template&id=4ad57170"
import script from "./SendWelcomeEmailButton.vue?vue&type=script&lang=js"
export * from "./SendWelcomeEmailButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports